import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { BrandLogoComponent, ImportsModule, sidebarActions, uiFeature } from '@mapa/ngx';
import { Store } from '@ngrx/store';
import { contactDetails } from '../../public/contact-us/data';
import { PUBLIC_MENU } from '../menu-items';

@Component({
  selector: 'header#app-header',
  standalone: true,
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ImportsModule,
    RouterModule,
    BrandLogoComponent
  ]
})
export class AppHeaderComponent {
  private readonly store = inject(Store);

  protected readonly contact = contactDetails;

  protected readonly navigating$ = this.store.selectSignal(uiFeature.selectNavigating);

  protected readonly icons = {
    faBars,
    faInstagram
  } as const;

  private readonly publicMenu$ = inject(PUBLIC_MENU);

  protected readonly menuItems$ = computed(() => this.publicMenu$().horizontal);

  protected toggleSidebar() {
    this.store.dispatch(sidebarActions.toggleExpansion());
  }

  protected removeLeafFocus(event: Event) {
    (event.target as HTMLElement)?.blur();
  }
}